import React from 'react';
import PropTypes from 'prop-types';
import { router, routerRedux } from 'dva';
import dynamic from 'dva/dynamic';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import App from './routes/app';
// import Home from './routes/home';
// import Topic from './routes/topic';
// import TopicDetail from './routes/topic/detail';
// import Bbs from './routes/bbs';
// import News from './routes/news';
// import Case from './routes/case';
// import Info from './routes/info';
// import Booth from './routes/booth';
// import BoothDetail from './routes/booth/detail';
import MicroVideo from './routes/microVideo';
import MicroVideo1 from './routes/microVideo1';


const {
  Switch, Route,
  Redirect,
} = router;

const { ConnectedRouter } = routerRedux;

moment.locale('zh-cn');
interface IRoutersProps {
  history: any;
  app: any;
}

const Routers: React.FC<IRoutersProps> = ({ history, app }) => {
  const error = dynamic({
    app,
    component: () => import('./routes/error'),
  } as any);
  const routes: any = [
    // {
    //   path: '/app/file',
    //   component: () => import('./routes/file'),
    // },
  ];

  return (
    <ConfigProvider locale={zhCN}>
      <ConnectedRouter history={history}>
        <App>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/app/home" />} />
            <Route exact path="/console" render={() => <Redirect to="/" />} />
            <Route exact path="/app/home" render={() => <MicroVideo />} />
            <Route exact path="/app/d9e6df3c-b90d-2eac-6f8c-ac4a75080903" render={() => <MicroVideo1 />} />
            {/* <Route exact path="/app/topic/:id" render={() => <Topic />} />
            <Route exact path="/app/topicDetail/:id" render={() => <TopicDetail />} />
            <Route exact path="/app/bbs/:id" render={() => <Bbs />} />
            <Route exact path="/app/news" render={() => <News />} />
            <Route exact path="/app/case" render={() => <Case />} />
            <Route exact path="/app/info" render={() => <Info />} />
            <Route exact path="/app/booth" render={() => <Booth />} />
            <Route exact path="/app/microvideo" render={() => <MicroVideo />} />
            <Route exact path="/app/booth/:id" render={() => <BoothDetail />} /> */}
            {routes.map(({ path, exact, ...dynamics }: any) => (
              <Route
                key={path}
                exact={exact !== false}
                path={path}
                component={dynamic({
                  app,
                  ...dynamics,
                } as any) as any}
              />
            ))}
            <Route component={error as any} />
          </Switch>
        </App>
      </ConnectedRouter>
    </ConfigProvider>
  );
};

Routers.propTypes = {
  history: PropTypes.object,
  app: PropTypes.object,
};

export default Routers;
